module.exports = __webpack_public_path__ + "assets/img/logo.fcef8cb5.png";